"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPapiBooking = isPapiBooking;
const legacy_enums_1 = require("@daytrip/legacy-enums");
/**
 * Checks if the booking is from PAPI (Partner or StatementOfBooking: Travel Agency statement of booking (paid by invoice at the end of the billing period)
 * @param paymentMethod The payment method to check.
 * @returns true if the payment method is from PAPI (Partner or StatementOfBooking), false otherwise.
 */
function isPapiBooking(paymentMethod) {
    return [legacy_enums_1.PaymentMethod.Partner, legacy_enums_1.PaymentMethod.StatementOfBooking].includes(paymentMethod);
}
//# sourceMappingURL=is-papi-booking.js.map